module.exports = __webpack_public_path__ + "img/scanCode.eb90aa48.png";